import { useState } from 'react';
import { useDispatch } from 'react-redux';

const useToaster = (autoClose = false) => {
    const dispatch = useDispatch();
    const [dateLancement, setDateLancement] = useState(null);
    const alertId = 'API_FF_APPEL'; // Pour garder l'identifiant de l'alerte

    const launchToaster = (messageToaster) => {
        setDateLancement(new Date());
        const alerte = {
            id: alertId,
            titre: 'Notification',
            type: 'info',
            description: messageToaster,
            autoClose,
        };

        dispatch({
            type: 'ALERTS_SHOW',
            alerte,
        });
    };

    const triggerToaster = (messageToaster = 'Vérifications auprès des fédérations en cours.') => {
        launchToaster(messageToaster);
    };

    const closeToaster = () => {
        const dureeDepuisLancement = new Date() - dateLancement;
        if (dureeDepuisLancement < 5000) {
            setTimeout(() => {
                dispatch({
                    type: 'ALERTS_HIDE',
                    id: alertId,
                });
            }, 5000 - dureeDepuisLancement);
        } else {
            dispatch({
                type: 'ALERTS_HIDE',
                id: alertId,
            });
        }
    };

    return {
        triggerToaster,
        closeToaster,
    };
};

export default useToaster;
